module.exports = __webpack_public_path__ + "img/calendar_green.5c551086.svg";